import { ReactNode } from 'react';

type Props = {
    dark?: boolean;
    gradient?: boolean;
    center?: boolean;
    header?: 'h1' | 'h2';
    title: string;
    description?: string;
    children?: ReactNode;
    image?: ReactNode;
    className?: string;
    headerClassName?: string;
    textClassName?: string;
    wrapperClassName?: string;
    imagePlacement?: 'left' | 'right';
};

export const Section = ({
    dark,
    gradient,
    header = 'h2',
    title,
    image,
    description,
    children,
    center,
    className,
    headerClassName,
    textClassName,
    wrapperClassName,
    imagePlacement,
}: Props) => {
    const H = header;

    return (
        <div
            className={`w-full px-8 md:px-12 pt-12 lg:pt-24 pb-24 ${gradient ? 'bg-gradient-to-b from-neutral-950 to-black' : dark ? 'bg-black' : 'bg-neutral-950'} items-center text-white flex flex-col justify-center gap-2 lg:gap-14 lg:flex-row-reverse ${wrapperClassName}`}
        >
            <div
                className={`lg:max-w-[1200px] ${center ? 'text-center items-center' : 'text-left items-start'} text-white flex flex-col justify-center gap-2 lg:gap-14 ${imagePlacement === 'left' ? 'lg:flex-row' : 'lg:flex-row-reverse'} ${className}`}
            >
                {image}
                <div
                    className={`${center ? 'text-center items-center' : 'text-left items-start'} flex flex-col justify-center lg:items-start gap-2`}
                >
                    <H
                        className={`font-bold ${header === 'h1' ? 'text-4xl' : 'text-3xl'} md:text-5xl whitespace-pre-wrap ${headerClassName}`}
                    >
                        {title}
                    </H>
                    {description && (
                        <p
                            className={`text-sm mt-2 mb-4 md:mb-8 md:mt-6 ${center && 'm-auto'} ${textClassName}`}
                        >
                            {description}
                        </p>
                    )}
                    {children}
                </div>
            </div>
        </div>
    );
};
